import { Navigate } from 'react-router-dom';
import { FC, ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useAppSelector } from '../hooks/useAppStore';
import { getAuthenticateUser } from '../store/authenticate/selectors';

const ProtectedRoute: FC<{ children: ReactNode }> = ({ children }) => {
  const { isLoggedIn, isTokenExpired } = useAuth();
  const { personnel } = useAppSelector(getAuthenticateUser);

  if (!isLoggedIn() || isTokenExpired() || !personnel
    || !personnel.permissionLevel) {
    return <Navigate to="/" />;
  }
  return children;
};

export {
  ProtectedRoute,
};
